import React from 'react';
import { AccountPosition } from '../types';
import PositionHeader from './PositionHeader';
import PositionDetails from './PositionDetails';
import PositionThesis from './PositionThesis';
import OptionsInformation from './OptionsInformation';
import PositionActions from './PositionActions';

interface PositionItemProps {
  position: AccountPosition;
  updating: string | null;
  getPositionTypeIcon: (positionType: string) => React.ReactNode;
  getRankIcon: (rank: number) => React.ReactNode;
  getRankColor: (rank: number) => string;
  getStatusColor: (status: string) => string;
  getPriorityColor: (priority: string) => string;
  isExpired: (expiresAt: string) => boolean;
  formatCurrency: (value: number) => string;
  formatPercentage: (value: number) => string;
  handleStatusUpdate: (
    positionId: string,
    newStatus: string,
    notes?: string,
  ) => void;
  handleCancelPosition: (positionId: string) => Promise<void>;
}

const PositionItem: React.FC<PositionItemProps> = ({
  position,
  updating,
  getPositionTypeIcon,
  getRankIcon,
  getRankColor,
  getStatusColor,
  getPriorityColor,
  isExpired,
  formatCurrency,
  formatPercentage,
  handleStatusUpdate,
  handleCancelPosition,
}) => {
  return (
    <div key={position._id} className="p-6">
      <PositionHeader
        position={position}
        getPositionTypeIcon={getPositionTypeIcon}
        getRankIcon={getRankIcon}
        getRankColor={getRankColor}
        getStatusColor={getStatusColor}
        getPriorityColor={getPriorityColor}
        isExpired={isExpired}
      />

      <PositionDetails position={position} formatCurrency={formatCurrency} />

      <PositionThesis position={position} />

      <OptionsInformation
        position={position}
        optionMarketData={{}}
        formatCurrency={formatCurrency}
        formatPercentage={formatPercentage}
      />

      <PositionActions
        position={position}
        updating={updating}
        handleStatusUpdate={handleStatusUpdate}
        handleCancelPosition={handleCancelPosition}
      />
    </div>
  );
};

export default PositionItem;
